import styled from '@emotion/styled/macro';

import { StyledForm } from '../../../../../styledComponents/Form/Form';

export const Wrapper = styled(StyledForm)`
  display: grid;
  grid-template-columns: 18.5rem 18.5rem 9.4375rem;
  grid-column-gap: 2rem;
  padding: 0 2.5rem 2rem 0;
`;
